"use client";

import {
  useCustomerBase
} from "./chunk-A6J237PD.mjs";
import {
  AutumnContext
} from "./chunk-EOSHPHLH.mjs";

// src/libraries/react/hooks/useCustomer.tsx
var useCustomer = (params) => {
  return useCustomerBase({
    params,
    AutumnContext
  });
};

export {
  useCustomer
};
